import { useEffect, useRef, useState } from 'react';

export const useLazyLoading = () => {
    const ref = useRef<HTMLDivElement | null>(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setIsInView(true);
                observer.disconnect();
            }
        });

        observer.observe(el);

        return () => observer.disconnect();
    }, []);

    return { ref, isInView };
};
